module.exports = __webpack_public_path__ + "static/media/personal-drinks-1.969a53a6.jpg";